import React, { Component } from 'react';
import "./Resume.css"
import pdf from '../img/CV.pdf'


class Resume extends Component {
  render() {
    return (
      <div id="resume" className="resume">
       <div>

           <p className="resprag">Find out what I've accomplished over the years</p>
           <h1 className="resph1">DIG A LITTLE DEEPER</h1>
           <button className="resbutton resbutton2"><a href={pdf} target = "_blank" rel="noopener noreferrer">Download Resume</a></button>
       </div>


      </div>
    );
  }
}

export default Resume;
